



































































































































































































































































































































































import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import API from "@/Api";
const namespace: string = "AppStore";
@Component
export default class AssignedCourse extends Vue {
  @Getter("role", { namespace }) public role: any;
  @Getter("name", { namespace }) public userName: any;
  public items: any = [];
  public loader: boolean = false;
  public dialog: boolean = false;
  public file: any = "";
  public id: number = 0;
  public isDocumentUpload: boolean = false;
  public certificates: any = [];
  
  public openDocumentUpload() {
    this.isDocumentUpload = true;
  }
  public dropDownList: any = [
    {
      id: 0,
      name: "Unknown",
    },
    {
      id: 1,
      name: "Yet to Start",
    },
    {
      id: 2,
      name: "In Progress",
    },
    {
      id: 3,
      name: "Completed",
    },
  ];
  public load() {
    this.loader = true;
    API.Instance.get("/api/assigned-courses").then((response) => {
      this.items = response.data;
      this.loader = false;
    });
  }
  public mounted() {
    this.load();
  }
  public openDialog(id: any) {
    this.dialog = true;
    this.id = id;
  }
  public handleFileUpload(event: any) {
    if (!this.isDocumentUpload) {
      this.file = event.target.files;
      const formData = new FormData();
      for (let x = 0; x < this.file.length; x++) {
        formData.append("file" + x, this.file[x]);
      }
      if (this.file.length > 0) {
        API.Instance.post("/api/assigned-courses/upload-data", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            this.$store.commit("AppStore/SNACK_BAR", {
              text: `File has been uploaded successfully!`,
              show: true,
            });
            this.file = null;
            this.load();
          })
          .catch(() => {
            this.$store.commit("AppStore/SNACK_BAR", {
              text: `Can't upload the given file, Please check the content!`,
              show: true,
            });
          });
      }
    }
    else {
      // upload-certificate
      this.file = event.target.files;
      const formData = new FormData();
      for (let x = 0; x < this.file.length; x++) {
        formData.append("file" + x, this.file[x]);
      }
      if (this.file.length > 0) {
        API.Instance.post("/api/assigned-courses/upload-certificate", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            this.$store.commit("AppStore/SNACK_BAR", {
              text: `File has been uploaded successfully!`,
              show: true,
            });
            this.file = null;
            this.certificates.push(response.data);
          })
          .catch(() => {
            this.$store.commit("AppStore/SNACK_BAR", {
              text: `Can't upload the given file, Please check the content!`,
              show: true,
            });
          });
      }
      console.log(this.certificates);
    }

  }
  public save() {
    this.loader = true;
    this.items.createdBy = 'Test';
    let files = "";
    for (let i = 0; i < this.certificates.length; i++) {
      files += `${this.certificates[i]},`;
    }
    this.items.certificateUrl = files;
    API.Instance.post('/api/assigned-courses', this.items)
      .then((data) => {
        this.loader = false;
        this.load();
      })
  }
  public downloadReport() {
    this.loader = true;
    API.Instance
      .get('/api/assigned-courses/report')
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'LMS_Assigned_Data_Report.csv';
        link.click();
        this.loader = false;
      });
  }
}
